import { Component, OnDestroy } from '@angular/core';
import { GlobalModalService } from '../../../services/global-modal/global-modal.service';
import { Subscription } from 'rxjs';
import { BookingService } from '../../../services/booking/booking.service';
import { LstorageService } from '../../../services/common/lstorage.service';
import { MyTripDetailsService } from '../../../services/my-trip-details/my-trip-details.service';
import { Router } from '@angular/router';
import { LSkeys } from '../../../configs/app.constants';
import { ROUTE_CONFIGS } from '../../../configs/routerConfig';
import { SnackbarService } from '../../../services/common/snackbar.service';
import { OrderDetailsModel } from '../../../models/api/my-trips.model';
import { MyTripsService } from '../../../services/my-trips/my-trips.service';

@Component({
  selector: 'app-global-order-complete-modal',
  templateUrl: './global-order-complete-modal.component.html',
  styleUrl: './global-order-complete-modal.component.scss'
})
export class GlobalOrderCompleteModalComponent implements OnDestroy {
  visible = false;
  order: any;
  subscription: Subscription;
  customTip = 0;
  selectedTip = 0;
  selectedRatingMap: { [orderId: number]: number } = {};
  commentMap: { [orderId: number]: string } = {};
  ratingFromServer = 0;
  visibleTipMap: any;
  gateway_unique_id: any;
  tipSubmittedMap: { [orderId: number]: boolean } = {};
  isCashPayment: boolean = false;
  private savedJustNow = false;
  private skippedJustNow = false;

  constructor(
    private modalService: GlobalModalService,
    private bookingServ: BookingService,
    private lstorageServ: LstorageService,
    private myTripDetailsServ: MyTripDetailsService,
    private router: Router,
    private snackbarServ: SnackbarService,
    private myTripsServ: MyTripsService,
  ) {
    this.subscription = this.modalService.orderComplete$.subscribe(data => {
      this.order = data;
      this.gateway_unique_id = data.gateway_unique_id;
      this.isCashPayment = data.payment?.payment_type === 'Cash';
      this.resetState(data);
      this.visible = true;
    });
    this.modalService.forceClose$.subscribe(() => {
      this.visible = false;
    });
  }
  closeModal() {
    this.visible = false;
    this.modalService.modalClosed();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  resetState(order: any) {
    const existingTip = order?.payment?.tip || 0;
    this.customTip = existingTip > 0 ? existingTip : 0;
    this.selectedTip = existingTip;
    this.selectedRatingMap[order.order_id] = 0;
    this.commentMap[order.order_id] = '';
    this.ratingFromServer = 0;
    this.savedJustNow = false;
    this.skippedJustNow = false;
  }

  get isHelperCategory(): boolean {
    return this.order?.category_id === 10;
  }


  selectTip() {
    const orderId = this.order?.order_id;
    if (!orderId) {
      return;
    }
    // if (!this.customTip || this.customTip <= 0 || this.tipSubmittedMap[orderId]) return;

    // Check if tip is 0 or empty/undefined, and show a toast/snackbar
    if (!this.customTip || this.customTip <= 0) {
      this.snackbarServ.showError("Please enter a valid tip amount.");
      return;
    }

    // Prevent submitting again if already submitted
    if (this.tipSubmittedMap[orderId]) return;

    const tipObj = {
      order_id: orderId,
      tip: this.customTip,
      gateway_unique_id: this.gateway_unique_id
    };

    const tipApi$ = this.isHelperCategory
      ? this.bookingServ.serviceTipForHelper(tipObj)
      : this.bookingServ.serviceTip(tipObj);

    tipApi$.subscribe({
      next: (res: any) => {
        if (res.success) {
          // Only update selectedTip and mark as submitted on actual success
          this.selectedTip = this.customTip;
          this.tipSubmittedMap[orderId] = true;
          this.snackbarServ.showSuccess(res.msg || "Tip submitted successfully.");
          if (this.order?.payment) {
            this.order.payment.tip = this.customTip;
          }
        } else {
          // Handle API returning success: 0 / false
          this.snackbarServ.showError(res.msg || "Tip submission failed.");
        }
      },
      error: () => {
        this.snackbarServ.showError("Tip submission failed.");
      }
    });
  }


  saveRating(): void {
    const authToken = this.lstorageServ.getItem(LSkeys.AUTH_TOKEN);
    const orderId = this.order?.order_id;
    if (!orderId) {
      return;
    }
    const rating = this.selectedRatingMap[orderId] || 0;
    const comment = this.commentMap[orderId] || '';

    if (rating === 0) {
      this.snackbarServ.showError("Please select a rating.");
      return;
    }
    const data = {
      access_token: authToken,
      order_id: orderId,
      ratings: rating,
      comments: comment
    };
    const ratingApi$ = this.isHelperCategory
      ? this.myTripDetailsServ.orderRatingForHelper(data)
      : this.myTripDetailsServ.orderRating(data);

    ratingApi$.subscribe(
      (response) => {
        this.ratingFromServer = rating;
        this.snackbarServ.showSuccess(response.msg);
        this.savedJustNow = true; 
        this.closeModal();
        setTimeout(() => this.viewDetailsAfterRating(orderId), 100);
      },
      () => this.snackbarServ.showError("Error saving rating.")
    );
  }

  onDialogHide(): void {
    if (this.savedJustNow || this.skippedJustNow) {
      this.savedJustNow = false;
      this.skippedJustNow = false;
      return;
    }
    this.skipRating();
  }


  skipRating(): void {
    if (this.skippedJustNow) {
      return;
    }
    this.skippedJustNow = true;
    const authToken = this.lstorageServ.getItem(LSkeys.AUTH_TOKEN);
    const orderId = this.order?.order_id
    if (!orderId) {
      this.skippedJustNow = false;
      return;
    }
    const data = {
      access_token: authToken,
      order_id: orderId,
      ratings: 0,
      comments: ''
    };

    const ratingApi$ = this.isHelperCategory
      ? this.myTripDetailsServ.orderRatingForHelper(data)
      : this.myTripDetailsServ.orderRating(data);

    ratingApi$.subscribe(
      (response) => {
        this.ratingFromServer = 0;
        this.snackbarServ.showSuccess(response.msg);
        this.closeModal();
        setTimeout(() => this.viewDetailsAfterRating(orderId), 100);
      },
      (error) => {
        this.skippedJustNow = false;
        this.snackbarServ.showError("Error skipping rating.");
      }
    );
  }


  viewDetailsAfterRating(orderId: number): void {
    const tokenExists = this.lstorageServ.getItem(LSkeys.AUTH_TOKEN) || '';
    let payload: OrderDetailsModel = {
      'access_token': tokenExists,
      'order_id': orderId
    };
    this.myTripsServ.orderDetails(payload).subscribe({
      next: (response) => {
        this.myTripDetailsServ.setOrderDetails(response);
        const targetUrl = `${ROUTE_CONFIGS.MY_ORDER_DETAILS_ROUTE}?order_id=${orderId}`;

        // Temporary detour to force reload
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl(targetUrl);
        });
      },
      error: (error) => {
        // console.error('Error fetching order details', error);
      }
    });
  }

get locationLabel(): string {
  return this.isHelperCategory ? 'SERVICE_LOCATION' : 'DROP_LOCATION';
}

get displayAddress(): string {
  if (!this.order) return '';
  return this.isHelperCategory
    ? this.order.pickup_address
    : this.order.dropoff_address;
}


}
